/**
 * AutomateMenu — the AI / automation entry points, grouped (menu label
 * "Automate").
 *
 * EIS is an AI eQMS; the AI surfaces are otherwise scattered. This gathers
 * them: show/hide the e-pilot chat, jump to Workflows, and reach the
 * AI-authored pipelines (AI Report Generation). Distinct from File
 * (signable deliverables) and Tools (record lifecycle).
 */
import React from 'react';
import {
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import {
  AutoAwesome,
  Chat,
  Route,
} from '@mui/icons-material';

const AutomateMenu = ({ anchorEl, open, onClose, hasProject, onSectionChange, onToggleChat }) => {
  const wrap = (fn) => () => { onClose(); fn?.(); };
  const nav = (section, tab = 0) => wrap(() => onSectionChange?.(section, tab));

  const row = (icon, label) => (
    <>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }}>{label}</ListItemText>
    </>
  );

  const gated = (node) => (
    <Tooltip title={hasProject ? '' : 'Select a product first'} placement="right">
      <span>{node}</span>
    </Tooltip>
  );

  return (
    <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
      <MenuItem dense onClick={wrap(onToggleChat)}>
        {row(<Chat fontSize="small" />, 'Toggle e-pilot')}
      </MenuItem>
      <MenuItem dense onClick={nav('orchestrator')}>
        {row(<Route fontSize="small" />, 'Workflows / Automation')}
      </MenuItem>
      <Divider />
      {gated(
        <MenuItem dense disabled={!hasProject} onClick={nav('documents', 1)}>
          {row(<AutoAwesome fontSize="small" />, 'AI Report Generation…')}
        </MenuItem>,
      )}
    </Menu>
  );
};

export default AutomateMenu;
